// extracted by mini-css-extract-plugin
export default {"box":"RawValidator_box__wv4iU","label":"RawValidator_label__QoNno","subLabel":"RawValidator_subLabel__lTB8G"};